module.exports = __webpack_public_path__ + "img/doc.a77c8a5c.png";